import { useAlertEmit } from "@fpsoftware/mvp";
import { useQueryClient, useSuspenseQuery } from "@tanstack/react-query";
import type { CompanyFeesPutBody } from "shared";
import { Api } from "@/api.config";
import { QueryKeys } from "@/LinkGen";

export function useCompanyFees() {
  const { data } = useSuspenseQuery({
    queryKey: QueryKeys.CompanyFees(),
    queryFn: () => Api.CompanyFees(),
  });

  return data;
}

export function useCompanyFeesActions() {
  const queryClient = useQueryClient();
  const emit = useAlertEmit();

  const updateFees = async (values: CompanyFeesPutBody) => {
    await Api.CompanyFeesPut(values);
    await queryClient.invalidateQueries({ queryKey: QueryKeys.CompanyFees() });
    emit({ type: "success", content: "Company fees updated successfully." });
  };

  return { updateFees };
}
